export default "/images/company4.png?9f369d04cca0ca558e733add0d7171d4";